module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-container"
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.backPages()
      }
    }
  }, [_vm._m(0)]), _vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ul', [_c('li', [_c('label', {
    attrs: {
      "for": "J_Phone"
    }
  }, [_vm._v("手机号码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.tel),
      expression: "user.tel"
    }],
    attrs: {
      "type": "text",
      "id": "J_Phone",
      "maxlength": "11",
      "placeholder": "请填写手机号码"
    },
    domProps: {
      "value": (_vm.user.tel)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Name"
    }
  }, [_vm._v("真实姓名：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    attrs: {
      "type": "text",
      "id": "J_Name",
      "maxlength": "15",
      "placeholder": "用于就诊信息调用,务必正确填写"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Pwd"
    }
  }, [_vm._v("新建密码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "type": "password",
      "id": "J_Pwd",
      "maxlength": "16",
      "placeholder": "请填写新建密码"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('pwd')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_SmsCodeNumber"
    }
  }, [_vm._v("图片校验码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.imgcode),
      expression: "user.imgcode"
    }],
    staticClass: "wh",
    attrs: {
      "type": "text",
      "id": "J_SmsCodeNumber",
      "maxlength": "4",
      "placeholder": "点击图片换一换"
    },
    domProps: {
      "value": (_vm.user.imgcode)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('smsCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.imgcode = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "codeimg"
  }, [_c('img', {
    attrs: {
      "src": "",
      "id": "J_SmsValidCode"
    },
    on: {
      "click": _vm.verifyCode
    }
  })])]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_CodeNumber"
    }
  }, [_vm._v("短信验证码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.msgcode),
      expression: "user.msgcode"
    }],
    staticClass: "wh",
    attrs: {
      "type": "text",
      "id": "J_CodeNumber",
      "maxlength": "6",
      "placeholder": "请填写短信验证码"
    },
    domProps: {
      "value": (_vm.user.msgcode)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('code')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.msgcode = $event.target.value
      }
    }
  }), _c('a', {
    staticClass: "msg",
    attrs: {
      "href": "javascript:;",
      "id": "J_GetCode"
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow-left"
  }, [_c('div', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "btn"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "id": "J_RegisterBtn",
      "value": "注册"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-65b03504"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 194
// module chunks = 1